import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../styles/NewStory.css';

function NewStory() {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [coverImage, setCoverImage] = useState(null);
  const [category, setCategory] = useState('');
  const [copyright, setCopyright] = useState('');
  const [isMatureContent, setIsMatureContent] = useState(false);
  const [coverImageError, setCoverImageError] = useState('');
  const [categoryError, setCategoryError] = useState('');
  const [copyrightError, setCopyrightError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const MAX_FILE_SIZE_MB = 2;
  const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
  const TARGET_FILE_SIZE_BYTES = 500 * 1024;

  const categories = [
    { id: 1, name: 'Aksiyon' }, { id: 2, name: 'Bilim Kurgu' }, { id: 3, name: 'Fantastik' },
    { id: 4, name: 'Genel Kurgu' }, { id: 5, name: 'Genç Kurgu' }, { id: 6, name: 'Gerilim' },
    { id: 7, name: 'Gizem' }, { id: 8, name: 'Hayran Kurgu' }, { id: 9, name: 'Klasikler' },
    { id: 10, name: 'Korku' }, { id: 11, name: 'Kısa Hikaye' }, { id: 12, name: 'Macera' },
    { id: 13, name: 'Mizah' }, { id: 14, name: 'Paranormal' }, { id: 15, name: 'Romantizm' },
    { id: 16, name: 'Spiritüel' }, { id: 17, name: 'Tarihi Kurgu' }, { id: 18, name: 'Texting' },
    { id: 19, name: 'Vampir' }, { id: 20, name: 'Şiir' }
  ];

  const copyrights = [
    { id: 1, name: 'Telif Hakkı Belirtilmemiş' }, { id: 2, name: 'Tüm Hakları Saklıdır' },
    { id: 3, name: 'Tüm Hakları Herkese Açık' }, { id: 4, name: 'Creative Commons (CC) İsnadı' },
    { id: 5, name: '(CC) Atıf-Gayriticari' }, { id: 6, name: '(CC) Atıf-Gayriticari-Türetilemez' },
    { id: 7, name: '(CC) Attrib. NonComm. Sürümleri ile' }, { id: 8, name: '(CC) Atıf-LisanDevam' },
    { id: 9, name: '(CC) Atıf-Türetilemez' }
  ];

  const compressImage = (file, maxWidth = 800, maxHeight = 1200, quality = 0.8) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        let { width, height } = img;

        if (width > maxWidth || height > maxHeight) {
          const widthRatio = maxWidth / width;
          const heightRatio = maxHeight / height;
          const ratio = Math.min(widthRatio, heightRatio);
          width *= ratio;
          height *= ratio;
        }

        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);

        const tryCompress = (q) => {
          canvas.toBlob((blob) => {
            if (blob.size > TARGET_FILE_SIZE_BYTES && q > 0.1) {
              tryCompress(q - 0.1);
            } else {
              const compressedFile = new File([blob], file.name, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              resolve(compressedFile);
            }
          }, 'image/jpeg', q);
        };

        tryCompress(quality);
      };

      img.src = URL.createObjectURL(file);
    });
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setCoverImageError('');
    setCategoryError('');
    setCopyrightError('');

    let hasError = false;

    if (!coverImage) {
      setCoverImageError('Kapak fotoğrafı yüklenmelidir.');
      hasError = true;
    }

    if (!category) {
      setCategoryError('Kategori seçilmelidir.');
      hasError = true;
    }

    if (!copyright) {
      setCopyrightError('Telif hakkı seçilmelidir.');
      hasError = true;
    }

    if (hasError) return;

    setSubmitting(true);

    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('cover_image', coverImage);
    formData.append('category_id', category);
    formData.append('telif_id', copyright);
    formData.append('is_mature_content', isMatureContent);

    const token = localStorage.getItem('token');

    if (!token) {
      setError('Oturum bilginiz bulunamadı. Lütfen tekrar giriş yapın.');
      setSubmitting(false);
      return;
    }

    try {
      console.log('Hikaye gönderiliyor...', { title, description, category, copyright, isMatureContent });

      const response = await api.post('/new-story', formData, {
        headers: {
          // 'Content-Type': 'multipart/form-data' — SİLİNDİ
          // Tarayıcı boundary'yi otomatik eklesin diye bu satır kaldırıldı
          Authorization: `Bearer ${token}`,
        },
      });

      console.log('API Yanıtı:', response.data);

      if (response.data && response.data.book_id) {
        const createdBook = response.data;
        console.log('Hikaye başarıyla oluşturuldu, edit sayfasına yönlendiriliyor:', createdBook);

        navigate('/edit-story', {
          state: {
            bookId: createdBook.book_id,
            title: createdBook.title,
            content: ''
          }
        });
      } else {
        setError('Hikaye oluşturuldu ancak ID alınamadı. Lütfen tekrar deneyin.');
        console.error('API yanıtında book_id bulunamadı:', response.data);
      }
    } catch (error) {
      console.error('Hikaye oluşturulurken hata:', error);

      if (error.code === 'NETWORK_ERROR' || error.message.includes('Network Error')) {
        setError('Dosya çok büyük olabilir. Lütfen daha küçük bir kapak fotoğrafı seçin.');
      } else {
        setError('Hikaye oluşturulurken bir hata oluştu: ' + (error.response?.data?.message || error.message));
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleCoverImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      setCoverImageError('Lütfen sadece resim dosyası seçin.');
      e.target.value = '';
      return;
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
      setCoverImageError(`Dosya çok büyük (${formatFileSize(file.size)}). Sıkıştırma işlemi başlatılıyor...`);
    }

    try {
      const compressedFile = await compressImage(file);

      console.log('Orijinal boyut:', formatFileSize(file.size));
      console.log('Sıkıştırılmış boyut:', formatFileSize(compressedFile.size));

      setCoverImage(compressedFile);
      setCoverImageError('');

      if (file.size > TARGET_FILE_SIZE_BYTES) {
        setCoverImageError(`✅ Resim başarıyla sıkıştırıldı (${formatFileSize(file.size)} → ${formatFileSize(compressedFile.size)})`);
        setTimeout(() => setCoverImageError(''), 3000);
      }
    } catch (error) {
      console.error('Resim sıkıştırma hatası:', error);
      setCoverImageError('Resim işlenirken bir hata oluştu. Lütfen farklı bir resim deneyin.');
      setCoverImage(null);
      e.target.value = '';
    }
  };

  return (
    <div className="new-story-page">
      <div className="new-story-container">
        <div className="new-story-header">
          <button className="new-story-back-button" onClick={handleCancel}>
            ←
          </button>
          <h1 className="new-story-title">{title || 'Yeni Hikaye'}</h1>
          <div className="new-story-header-spacer"></div>
        </div>

        {error && <div className="new-story-error-banner">{error}</div>}

        <div className="new-story-main-content">
          <div className="new-story-content-wrapper">
            <div className="new-story-cover-section">
              <div className="new-story-cover-upload">
                {coverImage ? (
                  <img src={URL.createObjectURL(coverImage)} alt="Kapak" className="new-story-cover-image" />
                ) : (
                  <div className="new-story-upload-placeholder">
                    <div className="new-story-upload-icon">📷</div>
                    <span className="new-story-upload-text">Kapak Fotoğrafı Ekle</span>
                    <small className="new-story-upload-hint">Maksimum 5MB</small>
                  </div>
                )}
                <input
                  type="file"
                  onChange={handleCoverImageChange}
                  accept="image/*"
                  className="new-story-file-input"
                />
              </div>
              {coverImageError && <div className="new-story-error-message">{coverImageError}</div>}
            </div>

            <div className="new-story-form-section">
              <div className="new-story-form-container">
                <h2 className="new-story-section-title">Hikaye Bilgileri</h2>

                <form onSubmit={handleSubmit} className="new-story-form">
                  <div className="new-story-form-group">
                    <label className="new-story-form-label">Başlık</label>
                    <input
                      type="text"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="Hikayen için bir başlık gir..."
                      className="new-story-form-input"
                      required
                    />
                  </div>

                  <div className="new-story-form-group">
                    <label className="new-story-form-label">Açıklama</label>
                    <textarea
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      placeholder="Hikayenin kısa bir açıklaması..."
                      className="new-story-form-textarea"
                      rows="4"
                    />
                  </div>

                  <div className="new-story-form-row">
                    <div className="new-story-form-group">
                      <label className="new-story-form-label">Kategori</label>
                      <select
                        value={category}
                        onChange={(e) => {
                          setCategory(e.target.value);
                          setCategoryError('');
                        }}
                        className="new-story-form-select"
                      >
                        <option value="">Kategori seç</option>
                        {categories.map((cat) => (
                          <option key={cat.id} value={cat.id}>{cat.name}</option>
                        ))}
                      </select>
                      {categoryError && <div className="new-story-error-message">{categoryError}</div>}
                    </div>

                    <div className="new-story-form-group">
                      <label className="new-story-form-label">Telif Hakkı</label>
                      <select
                        value={copyright}
                        onChange={(e) => {
                          setCopyright(e.target.value);
                          setCopyrightError('');
                        }}
                        className="new-story-form-select"
                      >
                        <option value="">Telif hakkı seç</option>
                        {copyrights.map((copy) => (
                          <option key={copy.id} value={copy.id}>{copy.name}</option>
                        ))}
                      </select>
                      {copyrightError && <div className="new-story-error-message">{copyrightError}</div>}
                    </div>
                  </div>

                  <div className="new-story-form-group">
                    <label className="new-story-form-label">İçerik Türü</label>
                    <select
                      value={isMatureContent ? 'true' : 'false'}
                      onChange={(e) => setIsMatureContent(e.target.value === 'true')}
                      className="new-story-form-select"
                    >
                      <option value="false">Genel İçerik</option>
                      <option value="true">Yetişkin İçerik</option>
                    </select>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="new-story-actions">
            <button
              type="button"
              onClick={handleCancel}
              className="new-story-button new-story-button-cancel"
            >
              İptal
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              disabled={submitting}
              className="new-story-button new-story-button-primary"
            >
              {submitting ? 'Oluşturuluyor...' : 'Hikaye Oluştur'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewStory;
